// @ts-nocheck

import OsagoBranchMultiplierForm from './OsagoBranchMultiplierForm';
import OsagoBranchMultiplierList from './OsagoBranchMultiplierList';

export default { OsagoBranchMultiplierList, OsagoBranchMultiplierForm };
